export default function isRgValid(rg) {
  // Remove todos os caracteres não numéricos exceto X
  const cleanRg = rg.replace(/[^\dXx]/g, '').toUpperCase();

  // RG deve ter entre 8 e 9 dígitos (incluindo o dígito verificador que pode ser X)
  if (cleanRg.length < 8 || cleanRg.length > 9) {
    return false;
  }

  // Verifica se não é uma sequência de números iguais
  if (/^(\d)\1+$/.test(cleanRg.replace(/X/g, ''))) {
    return false;
  }

  return true;
}
